import React from "react"
import classNames from "classnames"
import {withStyles, withWidth} from "@material-ui/core";
import styles from "./styles"
import Header from "../Components/Header";
import TitleWithText from "../Components/TitleWithText";
import {translate} from "react-i18next";
import {compose} from "redux";
import Footer from "../Components/Footer";
import {isWidthDown} from "@material-ui/core/withWidth";

const RouteAbout = ({t, classes, width}) => {
    const hasVScroll = document.body.scrollHeight > document.body.clientHeight;
    return (
    <div className={classNames({[`${classes.root}`]: !hasVScroll})}>
        <Header activePage={"about"}/>
        <div className={classes.elements}>
            <div className={classes.textElements}>
                <TitleWithText title={t("main:who_are_we")} text={t("main:who_are_we_text")}
                               titleSize={"35px"}/>
                <TitleWithText title={t("main:who_are_we_header2")} text={t("main:who_are_we_text2")}/>
                <TitleWithText title={t("main:who_are_we_header3")} text={t("main:who_are_we_text3")}/>
                {isWidthDown("sm", width)
                    ? <iframe title={"smallScreen"} width={320} height={200} src={"https://www.youtube.com/embed/ZGRWlYSmynY"} allowFullScreen/>
                    : <iframe title={"bigScreen"} width={720} height={420} src={"https://www.youtube.com/embed/ZGRWlYSmynY"} allowFullScreen/>}

            </div>
            <div className={classes.footer}>
                <Footer/>
            </div>
        </div>
    </div>
)};

export default compose(
    translate(),
    withWidth(),
    withStyles(styles)
)(RouteAbout)